import Box from "@mui/material/Box"

const Hub = ({ children }: any) => {
    return <Box component="main">
        {children}
    </Box>
}

export default Hub